function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import PropTypes from 'prop-types';
import List from "semantic-ui-react/dist/es/elements/List/List.js";
import { CONTACT_INFORMATION, EMAIL, LANGUAGES, PHONE, YOUR_HOST } from "../../../utils/default-strings";
import { Avatar } from "../../elements/Avatar";
import { size } from "../../../utils/size";
import { Heading } from "../../typography/Heading";
import { Grid } from "../../layout/Grid";
import { GridRow } from "../../layout/GridRow";
import { GridColumn } from "../../layout/GridColumn";
import { FlexContainer } from "../../layout/FlexContainer";
import { HTML } from "../../general-widgets/HTML";
import { getHrefTelString } from "../../../utils/get-href-tel-string";
import { getStringWithColonSuffix } from "./utils/getStringWithColonSuffix";
export var Component = function Component(_ref) {
  var avatarUrl = _ref.avatarUrl,
      contactInformationHeadingText = _ref.contactInformationHeadingText,
      description = _ref.description,
      email = _ref.email,
      emailLabel = _ref.emailLabel,
      headingText = _ref.headingText,
      languages = _ref.languages,
      languagesLabel = _ref.languagesLabel,
      name = _ref.name,
      phone = _ref.phone,
      phoneLabel = _ref.phoneLabel;

  var _name$split = name.split(' '),
      _name$split2 = _slicedToArray(_name$split, 2),
      firstName = _name$split2[0],
      lastName = _name$split2[1];

  return React.createElement(Grid, {
    textAlign: "left"
  }, React.createElement(GridRow, null, React.createElement(GridColumn, {
    width: 12
  }, React.createElement(Heading, null, headingText))), React.createElement(GridRow, null, React.createElement(GridColumn, {
    width: 12
  }, React.createElement(FlexContainer, {
    alignItems: "center",
    className: "avatar-container"
  }, React.createElement(Avatar, {
    firstName: firstName,
    image: avatarUrl,
    lastName: lastName
  }), React.createElement(Heading, {
    size: "small"
  }, name)))), React.createElement(GridRow, {
    verticalAlign: "top"
  }, size(description) > 0 && React.createElement(GridColumn, {
    computer: 7,
    mobile: 12,
    tablet: 12
  }, React.createElement(HTML, {
    htmlString: description
  })), React.createElement(GridColumn, {
    computer: 5,
    mobile: 12,
    tablet: 12
  }, React.createElement(Heading, {
    size: "small"
  }, contactInformationHeadingText), React.createElement(List, {
    relaxed: true,
    size: "medium"
  }, !!email && React.createElement(List.Item, null, React.createElement("span", null, getStringWithColonSuffix(emailLabel)), React.createElement("span", null, email)), !!phone && React.createElement(List.Item, null, React.createElement("span", null, getStringWithColonSuffix(phoneLabel)), React.createElement("span", null, React.createElement("a", {
    href: getHrefTelString(phone)
  }, phone))), !!languages && React.createElement(List.Item, null, React.createElement("span", null, getStringWithColonSuffix(languagesLabel)), React.createElement("span", null, languages.join(', ')))))));
};
Component.displayName = 'HostProfile';
Component.defaultProps = {
  avatarUrl: null,
  contactInformationHeadingText: CONTACT_INFORMATION,
  email: null,
  emailLabel: EMAIL,
  headingText: YOUR_HOST,
  languages: null,
  languagesLabel: LANGUAGES,
  phone: null,
  phoneLabel: PHONE,
  description: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  avatarUrl: PropTypes.string,
  contactInformationHeadingText: PropTypes.string,
  description: PropTypes.string,
  email: PropTypes.string,
  emailLabel: PropTypes.string,
  headingText: PropTypes.string,
  languages: PropTypes.arrayOf(PropTypes.string),
  languagesLabel: PropTypes.string,
  name: PropTypes.string.isRequired,
  phone: PropTypes.string,
  phoneLabel: PropTypes.string
} : {};